import { ErrorCode } from '@planning/utils/ErrorCode/error-code-enum'
import {
  getDomainModelExceptionPayload,
  isDomainModelException,
} from '@planning/utils/ErrorCode/error-code-utils'
import { useTranslate } from '@tolgee/react'

export const useTallymanMessageHandler = () => {
  const { t } = useTranslate()

  const getSuccessMessage = () => {
    return t('Success', 'Success')
  }

  const getCreateRestowFromRemainOnBoardExceptionMessage = (error: any) => {
    if (isDomainModelException(error, ErrorCode.EntityNotFound)) {
      const payload = getDomainModelExceptionPayload(error, ErrorCode.EntityNotFound)

      return t('entityNotFound', '{entity} with Id {id} not found', {
        entity: t('remainOnBoard', 'Remain on board'),
        id: payload?.id,
      })
    }

    if (isDomainModelException(error, ErrorCode.EntityAlreadyExists)) {
      return t(
        'cannotCreateAnotherRestowAsItAlreadyExists',
        'Cannot create another restow as it already exists',
      )
    }

    return error?.response?.data?.detail ?? t('somethingWentWrong', 'Something went wrong')
  }

  return {
    getCreateRestowFromRemainOnBoardExceptionMessage,
    getSuccessMessage,
  }
}
